import styled, { css } from 'styled-components';
import { CampaignMediaColors } from '../../types';

type CampaignBadgeProps = {
  campaignStyling?: CampaignMediaColors | null;
  size: 'small' | 'large';
};

export const CampaignBadge = styled.div<CampaignBadgeProps>(
  props => css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    width: 20px;
    border-radius: 10px;
    background: ${props.campaignStyling?.background || '#000'};

    ${props.size === 'large' &&
      css`
        width: 32px;
        height: 32px;
        border-radius: 16px;
      `}
  `
);
